export const tr = {
  timer: {
    activeTimers: 'Aktif Zamanlayıcı',
    noActiveTimers: 'Aktif zamanlayıcı bulunmuyor',
    pause: 'Duraklat',
    resume: 'Devam Et',
    stop: 'Durdur',
    confirmStop: 'Zamanlayıcıyı durdurmak istediğinizden emin misiniz? Bu işlem XP cezası uygulayacaktır.',
    completed: 'Tamamlandı',
    cancelled: 'İptal Edildi',
    remaining: 'Kalan',
    elapsed: 'Geçen'
  },
  discipline: {
    goals: 'Hedefler',
    stats: 'İstatistikler',
    xp: 'XP',
    streak: 'Seri',
    totalXP: 'Toplam XP',
    todayXP: 'Bugün Kazanılan XP',
    completedSessions: 'Tamamlanan Oturumlar',
    totalTime: 'Toplam Süre'
  },
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    edit: 'Düzenle',
    delete: 'Sil',
    add: 'Ekle',
    remove: 'Kaldır',
    close: 'Kapat',
    back: 'Geri',
    next: 'İleri',
    continue: 'Devam Et',
    confirm: 'Onayla',
    success: 'Başarılı',
    error: 'Hata',
    warning: 'Uyarı',
    info: 'Bilgi',
    loading: 'Yükleniyor...',
    processing: 'İşleniyor...',
    required: 'Zorunlu',
    optional: 'Opsiyonel'
  },
  profile: {
    editProfile: 'Kimlik Bilgilerini Düzenle',
    profileTitle: 'Profil',
    basicInfo: 'Temel Bilgiler',
    personalInfo: 'Kişisel Bilgiler',
    contactInfo: 'İletişim Bilgileri',
    emergencyInfo: 'Acil Durum Bilgileri',
    medicalInfo: 'Sağlık Bilgileri',
    physicalInfo: 'Fiziksel Bilgiler',

    // Basic Information
    name: 'İsim Soyisim',
    username: 'Kullanıcı Adı',
    bio: 'Hakkımda',
    dateOfBirth: 'Doğum Tarihi',
    gender: 'Cinsiyet',
    nationality: 'Uyruk',

    // Physical Information
    height: 'Boy',
    weight: 'Kilo',
    bloodType: 'Kan Grubu',
    eyeColor: 'Göz Rengi',
    hairColor: 'Saç Rengi',

    // Contact Information
    email: 'E-posta',
    phone: 'Telefon',
    secondaryEmail: 'Yedek E-posta',
    address: 'Adres',
    personalContact: 'Kişisel İletişim',

    // Emergency Information
    emergencyContacts: 'Acil Durum Kişileri',
    emergencyNotice: 'Acil Durum Bilgileri',
    emergencyDesc: 'Bu bilgiler acil durumlarda size ulaşmak ve sağlık durumunuzu değerlendirmek için kullanılacaktır.',
    contact: 'Kişi',
    contactDesc: 'Kişisel iletişim bilgileriniz ve acil durum için ulaşılacak kişiler.',
    noEmergencyContacts: 'Henüz acil durum kişisi eklenmemiş',
    addFirstContact: 'İlk Kişiyi Ekle',

    // Medical Information
    allergies: 'Alerjiler',
    conditions: 'Sağlık Durumları',
    medications: 'Kullandığınız İlaçlar',
    chronicDiseases: 'Kronik Hastalıklar',
    medicalConditions: 'Sağlık Durumları',
    medicalHistory: 'Tıbbi Geçmiş',
    noAllergies: 'Herhangi bir alerji kaydı bulunmuyor',
    noConditions: 'Herhangi bir sağlık durumu kaydı bulunmuyor',
    noMedications: 'Herhangi bir ilaç kaydı bulunmuyor',

    // Personal Preferences
    languages: 'Diller',
    hobbies: 'Hobiler',
    interests: 'İlgi Alanları',
    notes: 'Notlar',
    noLanguages: 'Herhangi bir dil kaydı bulunmuyor',
    noHobbies: 'Herhangi bir hobi kaydı bulunmuyor',

    // Relationships
    family: 'Aile',
    spouse: 'Eş',
    parent: 'Ebeveyn',
    sibling: 'Kardeş',
    friend: 'Arkadaş',
    doctor: 'Doktor',
    other: 'Diğer',
    relationship: 'İlişki',
    location: 'Konum',

    // Gender Options
    male: 'Erkek',
    female: 'Kadın',
    preferNotToSay: 'Belirtmek İstemiyorum',

    // Blood Types
    bloodTypeAPositive: 'A+',
    bloodTypeANegative: 'A-',
    bloodTypeBPositive: 'B+',
    bloodTypeBNegative: 'B-',
    bloodTypeABPositive: 'AB+',
    bloodTypeABNegative: 'AB-',
    bloodTypeOPositive: '0+',
    bloodTypeONegative: '0-',

    // Placeholders
    namePlaceholder: 'Ahmet Yılmaz',
    usernamePlaceholder: 'ahmetyilmaz',
    bioPlaceholder: 'Kendiniz hakkında kısa bir açıklama yazın...',
    emailPlaceholder: 'ahmet@example.com',
    phonePlaceholder: '+90 555 123 4567',
    addressPlaceholder: 'Mahalle, Sokak, İlçe, İl',
    heightPlaceholder: '175',
    weightPlaceholder: '70',
    allergyPlaceholder: 'Örn: Polen, Fıstık, İlaç',
    conditionPlaceholder: 'Örn: Hipertansiyon, Diyabet',
    medicationPlaceholder: 'Örn: Aspirin 100mg, Vitamin D',
    languagePlaceholder: 'Örn: Türkçe, English, Español',
    hobbyPlaceholder: 'Örn: Kitap okuma, Müzik, Spor',
    // Additional Identity Fields
    idNumber: 'TC Kimlik No',
    passport: 'Pasaport No',
    drivingLicense: 'Ehliyet No',
    socialSecurity: 'SGK No',
    taxNumber: 'Vergi No',
    profession: 'Meslek',
    workplace: 'İş Yeri',
    education: 'Eğitim Durumu',
    maritalStatus: 'Medeni Hal',
    children: 'Çocuk Sayısı',

    // Emergency Information Extensions
    emergencyMedicalInfo: 'Acil Tıbbi Bilgiler',
    emergencyInstructions: 'Acil Durum Talimatları',
    emergencyMedications: 'Acil Durum İlaçları',
    emergencyAllergies: 'Hayati Önem Taşıyan Alerjiler',
    insuranceInfo: 'Sigorta Bilgileri',
    insuranceCompany: 'Sigorta Şirketi',
    insuranceNumber: 'Sigorta Numarası',

    // Physical Information Extensions
    skinType: 'Cilt Tipi',
    bodyType: 'Vücut Tipi',
    fitness: 'Fitness Durumu',
    disabilities: 'Engellilik Durumu',
    prosthetics: 'Protez/İmplant',
    tattoos: 'Dövme/İşaret',
    scars: 'Yara İzi/Doğum Lekesi',

    // Medical Information Extensions
    bloodPressure: 'Kan Basıncı',
    heartRate: 'Nabız',
    temperature: 'Vücut Sıcaklığı',
    oxygenLevel: 'Oksijen Satürasyonu',
    medicalDevices: 'Tıbbi Cihazlar',
    vaccinations: 'Aşılar',
    medicalHistory: 'Tıbbi Geçmiş',
    surgeries: 'Ameliyatlar',
    hospitalizations: 'Hastane Yatışları',

    // Personal Preferences Extensions
    dietaryRestrictions: 'Diyet Kısıtlamaları',
    religiousInfo: 'Dini Bilgiler',
    politicalViews: 'Siyasi Görüş',
    personalValues: 'Kişisel Değerler',
    lifeGoals: 'Yaşam Hedefleri',
    personalMotto: 'Kişisel Motto',
    favoriteQuote: 'Favori Söz',

    // Privacy & Security
    privacyLevel: 'Gizlilik Seviyesi',
    dataSharing: 'Veri Paylaşımı',
    emergencyAccess: 'Acil Durum Erişimi',
    biometricAuth: 'Biyometrik Doğrulama',
    twoFactorAuth: 'İki Faktörlü Doğrulama',

    // Validation Messages
    nameRequired: 'İsim soyisim gereklidir',
    usernameRequired: 'Kullanıcı adı gereklidir',
    emailRequired: 'E-posta adresi gereklidir',
    phoneRequired: 'Telefon numarası gereklidir',
    invalidEmail: 'Geçerli bir e-posta adresi girin',
    invalidPhone: 'Geçerli bir telefon numarası girin',
    usernameTaken: 'Bu kullanıcı adı zaten alınmış',

    // Success Messages
    profileUpdated: 'Profil başarıyla güncellendi',
    emergencyContactAdded: 'Acil durum kişisi eklendi',
    emergencyContactRemoved: 'Acil durum kişisi kaldırıldı',

    // Tabs
    general: 'Genel',
    emergency: 'Acil Durum',
    medical: 'Sağlık',
    contacts: 'İletişim',
    personal: 'Kişisel',

    // QR Code
    qrId: 'QR Kimliğim',
    tattoo: 'Dövme'
  },
  dashboard: {
    emergencyInfo: 'Acil Durum Bilgileri',
    emergencyContacts: 'Acil Durum Kişileri',
    personalInfo: 'Kişisel Bilgiler',
    addEmergencyContact: 'Acil Durum Kişisi Ekle'
  },
  security: {
    security: 'Güvenlik',
    securityStatus: 'Güvenlik Durumu',
    accountSecure: 'Hesabınız güvenli',
    securityMeasuresActive: 'Tüm güvenlik önlemleri aktif.',
    twoFactorAuth: 'İki Faktörlü Kimlik Doğrulama',
    passwordStrength: 'Şifre Gücü',
    lastLogin: 'Son Giriş',
    active: 'Aktif',
    strong: 'Güçlü',
    today: 'Bugün',
    manageSecuritySettings: 'Güvenlik Ayarlarını Yönet'
  }, settings: {
    accountSettings: 'Hesap Ayarları',
    appSettings: 'Uygulama Ayarları',
    appSettingsDesc: 'Uygulama davranışı ve tercihlerini yönet',
    themeAndAppearance: 'Tema ve Görünüm',
    darkMode: 'Karanlık Mod',
    lightMode: 'Aydınlık Mod',
    languageAndRegion: 'Dil ve Bölge',
    languageSelection: 'Dil Seçimi',
    selectLanguageDescription: 'Uygulamayı kullanmak istediğiniz dili seçin.',
    helpAndSupport: 'Yardım ve Destek',
    confirmLogout: 'Çıkış yapmak istiyor musunuz?',
    logoutDescription: 'Hesabınızdan çıkış yapmak üzeresiniz. Tekrar giriş yapmanız gerekecek.',
    other: 'Diğer'
  },
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Güvenilir ağınız',
    tabs: {
      feed: 'Akış',
      connections: 'Ağ',
      vault: 'Kasa',
      create: 'Oluştur'
    },
    feed: {
      loadMore: 'Daha fazla gönderi yükle',
      document: 'Belge'
    },
    connections: {
      title: 'Ağ',
      add: 'Bağlan',
      followers: 'takipçi',
      projects: 'proje',
      message: 'Mesaj'
    },
    vault: {
      title: 'Dijital Kasa',
      access: 'Kasaya Eriş',
      notes: 'Notlar',
      photos: 'Fotoğraflar',
      audio: 'Ses',
      videos: 'Videolar',
      recent: 'Son Öğeler'
    },
    create: {
      title: 'Oluştur & Paylaş',
      subtitle: 'Bilgilerinizi ve projelerinizi ağınızla paylaşın',
      note: 'Not Oluştur',
      noteDesc: 'Düşüncelerinizi yazın ve paylaşın',
      voice: 'Sesli Not',
      voiceDesc: 'Ses kaydı ile düşüncelerinizi kaydedin',
      photo: 'Fotoğraf Paylaş',
      photoDesc: 'Görsel içerik yükleyin ve paylaşın',
      project: 'Yeni Proje',
      projectDesc: 'İşbirlikçi bir proje başlatın'
    }
  }, nav: {
    logout: 'Çıkış Yap',
    identityCircle: 'IdentityCircle'
  },
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Güvenilir sosyal ağınız',
    tabs: {
      feed: 'Akış',
      connections: 'Ağ',
      vault: 'Kasa',
      create: 'Oluştur'
    },
    feed: {
      title: 'Sosyal Akış',
      stories: 'Hikayeler',
      addStory: 'Hikaye Ekle',
      whatsOnMind: 'Aklından neler geçiyor?',
      shareThought: 'Düşünce Paylaş',
      loadMore: 'Daha fazla yükle',
      likes: 'beğeni',
      comments: 'yorum',
      shares: 'paylaşım',
      bookmarks: 'yer imi',
      timeAgo: {
        now: 'şimdi',
        minute: 'dk önce',
        hour: 'sa önce',
        day: 'gün önce',
        week: 'hafta önce'
      }
    },
    connections: {
      title: 'Güvenilir Ağ',
      add: 'Bağlantı Ekle',
      message: 'Mesaj',
      since: 'Bağlantı tarihi',
      followers: 'takipçi',
      following: 'takip edilen',
      projects: 'proje',
      verified: 'doğrulanmış',
      expert: 'uzman',
      trusted: 'güvenilir',
      online: 'çevrimiçi',
      offline: 'çevrimdışı'
    },
    vault: {
      title: 'Dijital Kasa',
      access: 'Kasaya Eriş',
      shareFromVault: 'Kasadan Paylaş',
      recentItems: 'Son Öğeler',
      notes: 'Notlar',
      photos: 'Fotoğraflar',
      audio: 'Ses Kayıtları',
      videos: 'Videolar',
      documents: 'Belgeler'
    },
    create: {
      title: 'İçerik Oluştur',
      whatToShare: 'Ne paylaşmak istiyorsun?', thought: 'Düşünce Paylaş',
      thoughtDesc: 'Fikirlerini ve görüşlerini paylaş',
      voice: 'Sesli Not',
      voiceDesc: 'Ses kaydı ile düşüncelerini kaydet ve paylaş',
      image: 'Fotoğraf/Resim',
      imageDesc: 'Görsel içerik yükle ve paylaş',
      video: 'Video',
      videoDesc: 'Video içerik oluştur ve paylaş',
      vault: 'Dijital Kasadan',
      vaultDesc: 'Özel kasandaki içerikleri paylaş', shareStats: 'İstatistik Paylaş',
      shareStatsDesc: 'İlerleme ve başarılarını paylaş'
    },
    privacy: {
      public: 'Herkese açık',
      connections: 'Sadece bağlantılar',
      private: 'Özel',
      selectAudience: 'Kitle seç'
    },
    post: {
      share: 'Paylaş',
      draft: 'Taslak',
      schedule: 'Zamanla',
      addLocation: 'Konum ekle', addTags: 'Etiket ekle',
      selectFromVault: 'Kasadan seç'
    }
  },
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Güvenilir sosyal katmanınız',
    visible: 'Görünür',
    hidden: 'Gizli',
    createContent: 'İçerik Oluştur',
    tabs: {
      connections: 'Bağlantılar',
      projects: 'Projeler',
      knowledge: 'Bilgi',
      identity: 'Kimlik'
    },
    create: {
      title: 'İçerik Oluştur',
      text: 'Metin Notu',
      voice: 'Sesli Not',
      image: 'Görsel',
      video: 'Video',
      stats: 'İstatistik Paylaş'
    },
    shareStats: {
      title: 'İstatistiklerinizi Paylaşın',
      share: 'İstatistikleri Paylaş'
    },
    connections: {
      title: 'Güvenilir Bağlantılar',
      add: 'QR ile Ekle',
      since: 'Bağlı olduğu tarih'
    },
    projects: {
      title: 'Projeler',
      create: 'Proje Oluştur'
    },
    knowledge: {
      title: 'Bilgi Paylaşımı',
      share: 'Bilgi Paylaş'
    }, identity: {
      title: 'Kimlik Yönetimi',
      privacy: 'Gizlilik Modu',
      privacyDesc: 'Aktivitenizi kimin görebileceğini kontrol edin',
      verification: 'Doğrulama Durumu'
    }
  },

  // Content Creation
  content: {
    createThought: 'Düşünce Paylaş',
    createVoice: 'Sesli Not',
    createImage: 'Fotoğraf Paylaş',
    createVideo: 'Video Paylaş',
    thoughtPlaceholder: 'Aklınızdan neler geçiyor?',
    voiceTitle: 'Sesli not başlığı (isteğe bağlı)',
    imageCaption: 'Bir açıklama yazın...',
    videoCaption: 'Bir açıklama yazın...',
    privacy: 'Gizlilik',
    recording: 'Kaydediliyor...',
    recordingComplete: 'Kayıt tamamlandı',
    tapToRecord: 'Kayıt başlatmak için dokunun',
    selectImage: 'Paylaşmak için bir resim seçin',
    selectVideo: 'Video oluşturun veya seçin',
    takePhoto: 'Fotoğraf Çek',
    chooseFromGallery: 'Galeriden Seç',
    recordVideo: 'Video Kaydet',
    chooseVideo: 'Galeriden Seç'
  },

  // Privacy Settings
  privacy: {
    public: 'Herkese Açık',
    publicDesc: 'Herkes görebilir',
    connections: 'Bağlantılar',
    connectionsDesc: 'Sadece güvenilir bağlantılarınız',
    private: 'Özel',
    privateDesc: 'Sadece siz görebilirsiniz'
  }
};

export default tr;
